<div class="container-fluid admin-page map-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Live map' | translate }}</h1>
            <p>{{ 'Locate active cars and focus the map on a selected car.' | translate }}</p>
        </div>
    </header>

    <section class="map-toolbar admin-toolbar">
        <label class="car-selector admin-filter-field">
            <span>{{ 'Car ID' | translate }}</span>
            <div class="car-select-wrap">
                <i class="material-icons car-select-icon">directions_car</i>
                <input (blur)="closeCarDropdown()"
                       (focus)="openCarDropdown()"
                       (keydown.enter)="selectFirstFilteredCar($event)"
                       (ngModelChange)="onCarSearchChanged($event)"
                       [disabled]="isLoadingCars"
                       [ngModel]="carSearchText"
                       aria-autocomplete="list"
                       [attr.aria-expanded]="isCarDropdownOpen"
                       aria-controls="car-options"
                       [attr.aria-label]="'Search and select a car ID' | translate"
                       autocomplete="off"
                       [placeholder]="'Search car ID' | translate"
                       role="combobox"
                       type="search">
                <button (click)="toggleCarDropdown()"
                        (mousedown)="$event.preventDefault()"
                        [disabled]="isLoadingCars"
                        [attr.aria-label]="'Toggle Car ID options' | translate"
                        class="car-select-toggle"
                        type="button">
                    <i class="material-icons">{{ isCarDropdownOpen ? 'expand_less' : 'expand_more' }}</i>
                </button>
                @if (isCarDropdownOpen) {
                    <div class="car-options" id="car-options" role="listbox">
                        @for (car of filteredCarIds; track car.fullIdentifier) {
                            <button (mousedown)="selectCar(car); $event.preventDefault()"
                                    [attr.aria-selected]="car.fullIdentifier === selectedCarId"
                                    [class.selected]="car.fullIdentifier === selectedCarId"
                                    role="option"
                                    type="button">{{ car.fullIdentifier }}
                            </button>
                        }
                        @if (filteredCarIds.length === 0) {
                            <span
                                    class="no-car-options">{{ 'No matching Car IDs' | translate }}</span>
                        }
                    </div>
                }
            </div>
        </label>
        <button (click)="resetCarSelection()"
                [disabled]="selectedCarId === '' && carSearchText === '' && resultOfSelection === ''"
                class="reset-filter-button" type="button">
            <i class="material-icons">filter_alt_off</i><span>{{ 'Reset' | translate }}</span>
        </button>
        @if (resultOfSelection !== '') {
            <div class="selection-result" role="status">
                <i class="material-icons">location_off</i>
                <span>{{ resultOfSelection | translate }}</span>
            </div>
        }
    </section>

    <section class="map-shell">
        <google-map [center]="mapCenter" [options]="mapOptions" [zoom]="zoom" height="100%" width="100%">
            @for (m of markers; track trackByItems(i, m); let i = $index) {
                <map-advanced-marker (gmpClick)="clickedMarker(m)"
                                     [content]="m.content"
                                     [gmpClickable]="true"
                                     [position]="m.position"
                                     [title]="m.title">
                </map-advanced-marker>
            }
            <map-info-window #carInfoWindow (closeclick)="onCarAnnotationClosed()"
                             [options]="carInfoWindowOptions"
                             [position]="selectedMapMarker?.position">
                @if (selectedMapMarker) {
                    <div class="car-info-window">
                        <header class="car-info-header">
                            <div>
                                <span>{{ 'Car' | translate }}</span>
                                <strong>{{ getMarkerTitle(selectedMapMarker) }}</strong>
                            </div>
                            <button (click)="closeCarAnnotation($event)"
                                    [attr.aria-label]="'Close' | translate"
                                    [title]="'Close' | translate"
                                    class="car-info-close" type="button">
                                <i class="material-icons">close</i>
                            </button>
                        </header>
                        <div class="car-info-body">
                            <span class="car-tracking-state">
                                <i class="material-icons">my_location</i>{{ 'Tracking this car' | translate }}
                            </span>
                            @if (selectedMapMarker.isBusy) {
                                @if (selectedMapMarker.isLoadingOrder) {
                                    <span class="car-order-state">
                                        <i class="material-icons spinning">refresh</i>
                                        {{ 'Loading active order...' | translate }}
                                    </span>
                                }
                                @if (!selectedMapMarker.isLoadingOrder && selectedMapMarker.activeOrder) {
                                    <span class="car-order-caption">{{ 'Active order' | translate }}</span>
                                    <button (click)="openOrderDetails(selectedMapMarker.activeOrder, $event)"
                                            [attr.aria-label]="'Open order details' | translate"
                                            class="car-order-link" type="button">
                                        {{ getOrderIdentifier(selectedMapMarker.activeOrder) }}
                                        <i class="material-icons">arrow_forward</i>
                                    </button>
                                }
                                @if (!selectedMapMarker.isLoadingOrder && selectedMapMarker.orderLookupComplete
                                && !selectedMapMarker.activeOrder) {
                                    <span class="car-order-state unavailable">
                                        {{ 'Active order unavailable.' | translate }}
                                    </span>
                                }
                            }
                            @if (selectedMapMarker.queuedOrder) {
                                <span [appOrderStatus]="'queued'"
                                      class="car-order-caption">{{ 'Queued order' | translate }}</span>
                                <button (click)="openOrderDetails(selectedMapMarker.queuedOrder, $event)"
                                        [attr.aria-label]="'Open order details' | translate"
                                        class="car-order-link" type="button">
                                    {{ getOrderIdentifier(selectedMapMarker.queuedOrder) }}
                                    <i class="material-icons">arrow_forward</i>
                                </button>
                            }
                        </div>
                    </div>
                }
            </map-info-window>
        </google-map>
    </section>
</div>

<app-order-details (closed)="closeOrderDetails()" [order]="selectedOrder"></app-order-details>
